import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-professional-banking.component.scss";
var FormItemProfessionalBanking = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemProfessionalBanking, _super);
    function FormItemProfessionalBanking(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemProfessionalBanking.prototype.init = function () {
        this.formFields = this.element.querySelector(".form__fields--container");
        this.form = this.element.querySelector("form");
        this.confirmContactNumberBtn = this.element.querySelector("input[name=confirm-phone-number]");
        this.buttonSubmit = this.element.querySelector(".js-professional-banking-submit");
        this.provincesSelect = this.form.querySelector(".js-professional-banking-province");
        this.citiesSelect = this.form.querySelector(".js-professional-banking-city");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        this.qualifications = this.form.querySelector(".js-qualification-type");
        this.populateData();
        this.populateProvinces();
        this.populateCity("");
    };
    FormItemProfessionalBanking.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input:not([data-name]), select, textarea");
                _this.validationService.validate(formFields);
                _this.professionalBankingValidations();
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    // success screens
                    var loader = _form.querySelector(".form__loader--container");
                    var fieldsContainer = _form.querySelector(".form__fields--container");
                    // loader + hide form
                    loader.classList.add("active");
                    fieldsContainer.classList.add("hidden");
                    // Check if gRecaptcha is enabled for this form
                    if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                        var gToken_1 = '';
                        try {
                            // Attempt to get recaptcha token
                            grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var err_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                        case 1:
                                            gToken_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_1 = _a.sent();
                                            // Log error
                                            console.log("Unable to retrieve gRecaptcha Token");
                                            console.log(err_1);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            // Set recaptcha token
                                            this.gRecaptchaToken = gToken_1;
                                            this.submitForm(_form);
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        catch (err) {
                            // Log error
                            console.log("Unable to retrieve gRecaptcha Token");
                            console.log(err);
                            _this.submitForm(_form);
                        }
                    }
                    else {
                        _this.submitForm(_form);
                    }
                }
            });
        }
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
                _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
                _this.dataSharingGroupShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute("hidden");
                _this.dataSharingGroupHideBtn.removeAttribute("hidden");
                _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
                _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute("hidden");
                _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        var _contactNumber = this.form.querySelector("input[name=contact-number]");
        var _contactConfirmNumber = this.form.querySelector("input[name=confirm-phone-number]");
        // Ok key
        if (this.confirmContactNumberBtn) {
            this.confirmContactNumberBtn.addEventListener("blur", function (e) {
                e.preventDefault();
                _this.validateConfirmContactNumber(_contactNumber, _contactConfirmNumber);
            });
        }
        if (this.provincesSelect) {
            this.provincesSelect.addEventListener("change", function (pEvent) {
                _this.populateCity(pEvent.target.value);
            });
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            var success = _this.element.querySelector(".form__success--container");
            if (success) {
                success.classList.remove("active");
            }
            var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
            valid.map(function (pElem) {
                pElem.classList.remove("form__group--error");
                var errorMessage = pElem.querySelector(".form__group--error_message");
                if (errorMessage) {
                    errorMessage.remove();
                }
            });
            _this.populateCity("");
        }, false);
    };
    FormItemProfessionalBanking.prototype.validateConfirmContactNumber = function (contactNumber, contactConfirmNumber) {
        var error = ["Confirm Phone number is not match"];
        var isValid = true;
        var _contactConfirmNumber = this.form.querySelector("input[name=confirm-phone-number]");
        if (contactNumber.value !== contactConfirmNumber.value) {
            //  Password doesnot match
            isValid = false;
            this.validationService.addError(_contactConfirmNumber, error);
        }
        return isValid;
    };
    FormItemProfessionalBanking.prototype.populateProvinces = function () {
        var _this = this;
        if (this.provincesSelect && this.provincesData) {
            this.provincesSelect.innerHTML = "";
            this.provincesData.map(function (pProvince) {
                var elem = _this.createOption(pProvince);
                _this.provincesSelect.appendChild(elem);
            });
        }
    };
    FormItemProfessionalBanking.prototype.populateCity = function (pEvent) {
        var _this = this;
        if (pEvent === void 0) { pEvent = null; }
        if (pEvent === "") {
            this.resetCitySelect();
        }
        else {
            if (this.citiesSelect && this.provincesData) {
                this.citiesSelect.innerHTML = "";
                var _province = this.provincesData.find(function (pProvince) {
                    if (pProvince.value === pEvent) {
                        return pProvince;
                    }
                });
                if (_province && _province.children.length > 0) {
                    _province.children.map(function (pCity) {
                        var elem = _this.createOption(pCity);
                        _this.citiesSelect.appendChild(elem);
                        var citiesSelectGroup = _this.citiesSelect.closest(".form__group");
                        citiesSelectGroup.classList.remove("form__group--hidden");
                    });
                }
                else {
                    this.resetCitySelect();
                }
            }
            else {
                this.resetCitySelect();
            }
        }
    };
    FormItemProfessionalBanking.prototype.resetCitySelect = function () {
        this.citiesSelect.innerHTML = "";
        var elem = document.createElement("option");
        elem.textContent = "Please select";
        elem.value = "";
        this.citiesSelect.appendChild(elem);
        var citiesSelectGroup = this.citiesSelect.closest(".form__group");
        citiesSelectGroup.classList.add("form__group--hidden");
    };
    FormItemProfessionalBanking.prototype.createOption = function (pData) {
        var elem = document.createElement("option");
        elem.textContent = pData.name;
        elem.value = pData.value;
        return elem;
    };
    FormItemProfessionalBanking.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemProfessionalBanking.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        var _clientName = form.querySelector("input[name=first-name]");
        var postData = "";
        var productType = form.querySelector("input[name=productType]");
        postData += "product=" + (productType ? productType.value : "");
        var firstName = form.querySelector("input[name=first-name]");
        postData += "&firstname=" + (firstName ? firstName.value : "");
        var surname = form.querySelector("input[name=surname]");
        postData += "&surname=" + (surname ? surname.value : "");
        var contactNumber = form.querySelector("input[name=contact-number]");
        postData += "&contact=" + (contactNumber ? contactNumber.value : "");
        var emailAddress = form.querySelector("input[name=emailAddress]");
        postData += "&emailAddress=" + (emailAddress ? emailAddress.value : "");
        var idNumber = form.querySelector("input[name=id-number]");
        postData += "&idNumber=" + (idNumber ? idNumber.value : "");
        var province = form.querySelector("select[name=province]");
        postData += "&province=" + (province ? province.value : "");
        var city = form.querySelector("select[name=city]");
        postData += "&area=" + (city ? city.value : "");
        var qualifications = form.querySelector("select[name=qualifications]");
        postData +=
            "&qualifications=" + (qualifications ? qualifications.value : "");
        var whatcanwehelpyouwith = form.querySelector("select[name=whatcanwehelpyouwith]");
        if (whatcanwehelpyouwith) {
            postData +=
                "&whatcanwehelpyouwith=" +
                    (whatcanwehelpyouwith ? whatcanwehelpyouwith.value : "");
        }
        var popiConsent = form.querySelector("input[name=popia-consent]");
        postData +=
            "&popiConsent=" +
                (popiConsent ? (popiConsent.checked ? "YES" : "NO") : "NO");
        postData +=
            "&dataPrivacyConsent=" +
                (popiConsent ? (popiConsent.checked ? "YES" : "NO") : "NO");
        postData +=
            "&dataSharingWithinOurGrpMarketingConsent=" +
                this.getDataConsentValue(form, "data-sharing-group");
        postData +=
            "&dataSharingWithThirdPartiesMarketingConsent=" +
                this.getDataConsentValue(form, "data-sharing-3rd-party");
        postData +=
            "&dataSharingAcrossBordersWithinOurGrpMarketingConsent=" +
                this.getDataConsentValue(form, "data-sharing-boarders");
        postData += "&recaptchaToken=" + this.gRecaptchaToken;
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/AMSLeadsForm.jsp";
        // service
        this.formsService
            .postForm(url, postData)
            .then(function (response) {
            loader.classList.remove("active");
            if (!response.data || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                loader.classList.remove("active");
                thankYou.classList.add("active");
                error.classList.add("active");
            }
            else {
                if (response.data.captchaResponse != null && response.data.captchaResponse == false) {
                    analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                    loader.classList.remove("active");
                    thankYou.classList.add("active");
                    error.classList.add("active");
                }
                else {
                    if (name) {
                        name.map(function (_item) {
                            _item.innerHTML = _clientName.value;
                        });
                    }
                    analyticsService.dtmFormComplete("complete", "false", false, "", emailAddress.value, contactNumber.value);
                    loader.classList.remove("active");
                    thankYou.classList.add("active");
                    success.classList.add("active");
                }
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url);
            loader.classList.remove("active");
            thankYou.classList.add("active");
            error.classList.add("active");
        });
    };
    // -- CUSTOM PROFESSIONAL BANKING VALIDATIONS -- //
    FormItemProfessionalBanking.prototype.professionalBankingValidations = function () {
        var fieldErrorDetails = "This field should not be more than 80 characters";
        var validationErrors = false;
        // First Name
        var firstName = this.element.querySelector('input[name="first-name"');
        var firstNameGroup = firstName.closest(".form__group");
        // Surname
        var surname = this.element.querySelector('input[name="surname"');
        var surnameGroup = surname.closest(".form__group");
        // First Name Error
        if (!firstNameGroup.classList.contains("form__group--hidden")) {
            if (firstName.value.length > 80) {
                validationErrors = true;
                firstNameGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = fieldErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                firstNameGroup.appendChild(_errorDiv);
            }
        }
        // Surname Error
        if (!surnameGroup.classList.contains("form__group--hidden")) {
            if (surname.value.length > 80) {
                validationErrors = true;
                surnameGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = fieldErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                surnameGroup.appendChild(_errorDiv);
            }
        }
    };
    FormItemProfessionalBanking.prototype.populateData = function () {
        this.provincesData = [
            {
                name: "Please select",
                value: "",
                children: [],
            },
            {
                name: "Free State",
                value: "Free State Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Bethlehem",
                        value: "Bethlehem",
                    },
                    {
                        name: "Bloemfontein",
                        value: "Bloemfontein",
                    },
                    {
                        name: "Sasolburg",
                        value: "Sasolburg",
                    },
                    {
                        name: "Welkom",
                        value: "Welkom",
                    },
                ],
            },
            {
                name: "Eastern Cape",
                value: "Eastern Cape Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Buffalo City",
                        value: "Buffalo City",
                    },
                    {
                        name: "Mthatha",
                        value: "Mthatha",
                    },
                    {
                        name: "Nelson Mandela Bay",
                        value: "Nelson Mandela Bay",
                    },
                    {
                        name: "Sarah Baartman",
                        value: "Sarah Baartman",
                    },
                ],
            },
            {
                name: "Gauteng",
                value: "Gauteng Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Alberton",
                        value: "Alberton",
                    },
                    {
                        name: "Bedfordview",
                        value: "Bedfordview",
                    },
                    {
                        name: "Benoni",
                        value: "Benoni",
                    },
                    {
                        name: "Benrose",
                        value: "Benrose",
                    },
                    {
                        name: "Boksburg",
                        value: "Boksburg",
                    },
                    {
                        name: "Braamfontein",
                        value: "Braamfontein",
                    },
                    {
                        name: "Carletonville",
                        value: "Carletonville",
                    },
                    {
                        name: "Centurion",
                        value: "Centurion",
                    },
                    {
                        name: "Clearwater",
                        value: "Clearwater",
                    },
                    {
                        name: "Cradlestone",
                        value: "Cradlestone",
                    },
                    {
                        name: "Crown Mines",
                        value: "Crown Mines",
                    },
                    {
                        name: "Eastgate",
                        value: "Eastgate",
                    },
                    {
                        name: "Fourways",
                        value: "Fourways",
                    },
                    {
                        name: "Gezina",
                        value: "Gezina",
                    },
                    {
                        name: "Greenstone",
                        value: "Greenstone",
                    },
                    {
                        name: "Hatfield",
                        value: "Hatfield",
                    },
                    {
                        name: "Hyde Park",
                        value: "Hyde Park",
                    },
                    {
                        name: "Kempton",
                        value: "Kempton",
                    },
                    {
                        name: "Keywest",
                        value: "Keywest",
                    },
                    {
                        name: "Killarney",
                        value: "Killarney",
                    },
                    {
                        name: "Krugersdorp",
                        value: "Krugersdorp",
                    },
                    {
                        name: "Lanseria",
                        value: "Lanseria",
                    },
                    {
                        name: "Laudium",
                        value: "Laudium",
                    },
                    {
                        name: "Library Gardens",
                        value: "Library Gardens",
                    },
                    {
                        name: "Lynnwood",
                        value: "Lynnwood",
                    },
                    {
                        name: "Mabopane",
                        value: "Mabopane",
                    },
                    {
                        name: "Mayfair",
                        value: "Mayfair",
                    },
                    {
                        name: "Melville",
                        value: "Melville",
                    },
                    {
                        name: "Menlyn",
                        value: "Menlyn",
                    },
                    {
                        name: "Midrand",
                        value: "Midrand",
                    },
                    {
                        name: "Montana",
                        value: "Montana",
                    },
                    {
                        name: "Nigel",
                        value: "Nigel",
                    },
                    {
                        name: "Northcliff",
                        value: "Northcliff",
                    },
                    {
                        name: "Northgate",
                        value: "Northgate",
                    },
                    {
                        name: "Ormonde",
                        value: "Ormonde",
                    },
                    {
                        name: "Park Station",
                        value: "Park Station",
                    },
                    {
                        name: "Parktown",
                        value: "Parktown",
                    },
                    {
                        name: "Pretoria CBD",
                        value: "Pretoria CBD",
                    },
                    {
                        name: "Pretoria North",
                        value: "Pretoria North",
                    },
                    {
                        name: "Pretoria West",
                        value: "Pretoria West",
                    },
                    {
                        name: "Randfontein",
                        value: "Randfontein",
                    },
                    {
                        name: "Randpark Ridge",
                        value: "Randpark Ridge",
                    },
                    {
                        name: "Rivonia",
                        value: "Rivonia",
                    },
                    {
                        name: "Rosebank",
                        value: "Rosebank",
                    },
                    {
                        name: "Sandton",
                        value: "Sandton",
                    },
                    {
                        name: "Selby",
                        value: "Selby",
                    },
                    {
                        name: "Silverton",
                        value: "Silverton",
                    },
                    {
                        name: "Southdale",
                        value: "Southdale",
                    },
                    {
                        name: "Soweto",
                        value: "Soweto",
                    },
                    {
                        name: "Springs",
                        value: "Springs",
                    },
                    {
                        name: "Sunninghill",
                        value: "Sunninghill",
                    },
                    {
                        name: "Sunnyside",
                        value: "Sunnyside",
                    },
                    {
                        name: "The Glen",
                        value: "The Glen",
                    },
                    {
                        name: "Vaal",
                        value: "Vaal",
                    },
                    {
                        name: "Westgate",
                        value: "Westgate",
                    },
                ],
            },
            {
                name: "KwaZulu-Natal",
                value: "KwaZulu Natal Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Amanzimtoti",
                        value: "Amanzimtoti",
                    },
                    {
                        name: "Assagay",
                        value: "Assagay",
                    },
                    {
                        name: "Ballito",
                        value: "Ballito",
                    },
                    {
                        name: "Berea",
                        value: "Berea",
                    },
                    {
                        name: "Bluff",
                        value: "Bluff",
                    },
                    {
                        name: "Bothas Hill",
                        value: "Bothas Hill",
                    },
                    {
                        name: "Briardene",
                        value: "Briardene",
                    },
                    {
                        name: "Camperdown",
                        value: "Camperdown",
                    },
                    {
                        name: "Cato Ridge",
                        value: "Cato Ridge",
                    },
                    {
                        name: "Chatsworth",
                        value: "Chatsworth",
                    },
                    {
                        name: "Durban North",
                        value: "Durban North",
                    },
                    {
                        name: "Empangeni",
                        value: "Empangeni",
                    },
                    {
                        name: "Eshowe",
                        value: "Eshowe",
                    },
                    {
                        name: "Kingsmead",
                        value: "Kingsmead",
                    },
                    {
                        name: "Kloof",
                        value: "Kloof",
                    },
                    {
                        name: "Margate",
                        value: "Margate",
                    },
                    {
                        name: "Msunduzi",
                        value: "Msunduzi",
                    },
                    {
                        name: "Mtubatuba",
                        value: "Mtubatuba",
                    },
                    {
                        name: "Newcastle",
                        value: "Newcastle",
                    },
                    {
                        name: "Pinetown",
                        value: "Pinetown",
                    },
                    {
                        name: "Port Edward",
                        value: "Port Edward",
                    },
                    {
                        name: "Port Shepstone",
                        value: "Port Shepstone",
                    },
                    {
                        name: "Queensburgh",
                        value: "Queensburgh",
                    },
                    {
                        name: "Richards Bay",
                        value: "Richards Bay",
                    },
                    {
                        name: "Scottsburg",
                        value: "Scottsburg",
                    },
                    {
                        name: "Shelly Beach",
                        value: "Shelly Beach",
                    },
                    {
                        name: "Sherwood",
                        value: "Sherwood",
                    },
                    {
                        name: "Springfield",
                        value: "Springfield",
                    },
                    {
                        name: "Ulundi",
                        value: "Ulundi",
                    },
                    {
                        name: "Umbilo",
                        value: "Umbilo",
                    },
                    {
                        name: "Umhlanga",
                        value: "Umhlanga",
                    },
                    {
                        name: "Umlazi",
                        value: "Umlazi",
                    },
                    {
                        name: "Umzinto",
                        value: "Umzinto",
                    },
                    {
                        name: "Verulam",
                        value: "Verulam",
                    },
                    {
                        name: "Westville",
                        value: "Westville",
                    },
                ],
            },
            {
                name: "Limpopo",
                value: "Limpopo Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Limpopo North",
                        value: "Limpopo North ",
                    },
                    {
                        name: "Nylstroom",
                        value: "Nylstroom",
                    },
                    {
                        name: "Polokwane",
                        value: "Polokwane",
                    },
                    {
                        name: "Louis Trichardt",
                        value: "Louis Trichardt",
                    },
                ],
            },
            {
                name: "Mpumalanga",
                value: "Mpumalanga Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Nelspruit",
                        value: "Nelspruit",
                    },
                    {
                        name: "Secunda",
                        value: "Secunda",
                    },
                    {
                        name: "Witbank",
                        value: "Witbank",
                    },
                ],
            },
            {
                name: "Northern Cape",
                value: "Northern Cape Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Kimberley",
                        value: "Kimberley",
                    },
                    {
                        name: "Kuruman",
                        value: "Kuruman",
                    },
                ],
            },
            {
                name: "Western Cape",
                value: "Western Cape Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Blue Route",
                        value: "Blue Route",
                    },
                    {
                        name: "Brackenfell",
                        value: "Brackenfell",
                    },
                    {
                        name: "Camps Bay",
                        value: "Camps Bay",
                    },
                    {
                        name: "Claremont",
                        value: "Claremont",
                    },
                    {
                        name: "Durbanville",
                        value: "Durbanville",
                    },
                    {
                        name: "George",
                        value: "George",
                    },
                    {
                        name: "Gordons Bay",
                        value: "Gordons Bay",
                    },
                    {
                        name: "Hermanus",
                        value: "Hermanus",
                    },
                    {
                        name: "Houtbay",
                        value: "Houtbay",
                    },
                    {
                        name: "Khayelitsha",
                        value: "Khayelitsha",
                    },
                    {
                        name: "Knysna",
                        value: "Knysna",
                    },
                    {
                        name: "Kuils River",
                        value: "Kuils River",
                    },
                    {
                        name: "Milnerton",
                        value: "Milnerton",
                    },
                    {
                        name: "N1 City",
                        value: "N1 City",
                    },
                    {
                        name: "Newlands",
                        value: "Newlands",
                    },
                    {
                        name: "Parow",
                        value: "Parow",
                    },
                    {
                        name: "Rondebosch",
                        value: "Rondebosch",
                    },
                    {
                        name: "Sea Point",
                        value: "Sea Point",
                    },
                    {
                        name: "Somerset West",
                        value: "Somerset West",
                    },
                    {
                        name: "Stellenbosch",
                        value: "Stellenbosch",
                    },
                    {
                        name: "Tableview",
                        value: "Tableview",
                    },
                    {
                        name: "Tygerberg",
                        value: "Tygerberg",
                    },
                    {
                        name: "Vredenburg",
                        value: "Vredenburg",
                    },
                    {
                        name: "Worcester",
                        value: "Worcester",
                    },
                ],
            },
            {
                name: "North West",
                value: "North West Province",
                children: [
                    {
                        name: "Please select",
                        value: "",
                    },
                    {
                        name: "Klerksdorp",
                        value: "Klerksdorp",
                    },
                    {
                        name: "Rustenburg",
                        value: "Rustenburg",
                    },
                ],
            },
        ];
    };
    return FormItemProfessionalBanking;
}(Base));
export { FormItemProfessionalBanking };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-professional-banking/form-item-professional-banking.component.ts
// module id = 971
// module chunks = 0